var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterDark = function SvgTwitterDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Circle Black"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    className: "Twitter_dark_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3 27.74a19.8 19.8 0 0 1-5.61 1.54A9.76 9.76 0 0 0 65 23.87a19.5 19.5 0 0 1-6.2 2.37 9.77 9.77 0 0 0-16.89 6.68 10.2 10.2 0 0 0 .25 2.23A27.78 27.78 0 0 1 22 25a9.77 9.77 0 0 0 3 13 9.8 9.8 0 0 1-4.43-1.22v.13a9.77 9.77 0 0 0 7.84 9.57 9.95 9.95 0 0 1-4.41.17 9.76 9.76 0 0 0 9.12 6.78A19.6 19.6 0 0 1 21 57.59a20 20 0 0 1-2.33-.14 27.55 27.55 0 0 0 15 4.39c18 0 27.79-14.88 27.79-27.78v-1.27a19.8 19.8 0 0 0 4.84-5.05",
    className: "Twitter_dark_svg__cls-2",
    "data-name": "Twitter"
  }))));
};
export default SvgTwitterDark;